import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as aliases from '../../../../../aliases'
import type { Feature } from '../feature'

/**
 * Updates the aliases store with the widget alias / id pair after successful rendering of the widget.
 */
export const putWidgetAlias = store.effects.create(
  (feature: Feature, aliasesFeature: aliases.Feature) =>
    feature.actions.render.success.observe().pipe(
      rxjs.map(
        ({
          data: {
            response: { rendering },
          },
        }) =>
          aliasesFeature.actions.putAlias
            .from('putWidgetAlias (effect)')
            .create({ widget: rendering }),
      ),
    ),
)
